import { render } from "./TheMovie.vue?vue&type=template&id=6ab4ba07&scoped=true"
import script from "./TheMovie.vue?vue&type=script&lang=js"
export * from "./TheMovie.vue?vue&type=script&lang=js"

import "./TheMovie.vue?vue&type=style&index=0&id=6ab4ba07&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab4ba07"]])

export default __exports__